import { Button } from '@amzn/awsui-components-core';
import React from 'react';
import { eTicketLinks } from 'src/constants/AppConstants';

interface FinsuiteIssueActionButtonProps {
  ticketLink?: string;
}
export const FinsuiteIssueActionButton: React.FC<FinsuiteIssueActionButtonProps> = ({ ticketLink }) => {
  return (
    <Button
      ariaLabel="Report a bug (opens new tab)"
      href={ticketLink || eTicketLinks.DAS_FINSUITE_GENERAL_ISSUE}
      iconAlign="right"
      iconName="external"
      target="_blank"
    >
      Cut us a Ticket
    </Button>
  );
};
